import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { ChalkboardTeacher, Users, CheckCircle, Eye, Plus, PencilSimple } from "@phosphor-icons/react";

export default function InstructorPanel() {
  const [courses, setCourses] = useState([]);
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  useEffect(() => { api.get("/instructor/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);

  const viewResults = async (c) => {
    setCurrent(c); setOpen(true);
    const { data } = await api.get(`/instructor/courses/${c.id}/results`);
    setResults(data);
  };

  return (
    <div>
      <p className="text-xs uppercase tracking-overline text-primary mb-1 font-mono">Panel del Relator</p>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-8">
        <h1 className="font-display text-3xl font-800 tracking-tight">Mis cursos y resultados</h1>
        <Link to="/dashboard/curso-editor/new"><Button className="bg-primary text-white hover:bg-blue-600 gap-2" data-testid="instr-new-course"><Plus size={18} /> Crear curso</Button></Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {courses.length === 0 && <p className="text-muted-foreground">No tienes cursos asignados.</p>}
        {courses.map((c) => (
          <div key={c.id} className="bg-white border border-border rounded-lg overflow-hidden" data-testid={`instr-course-${c.id}`}>
            <div className="aspect-video bg-secondary overflow-hidden"><img src={c.image_url} alt="" className="w-full h-full object-cover" /></div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs font-mono text-primary uppercase">{c.category}</span>
                {c.published ? <Badge className="bg-primary text-white text-[10px]">Publicado</Badge> : <Badge variant="outline" className="text-[10px]">Borrador</Badge>}
              </div>
              <h3 className="font-display font-700 tracking-tight line-clamp-2">{c.title}</h3>
              <div className="flex items-center gap-4 text-sm text-muted-foreground mt-3">
                <span className="flex items-center gap-1"><Users size={15} /> {c.enrollments} alumnos</span>
                <span className="flex items-center gap-1"><CheckCircle size={15} /> {c.passed} aprobados</span>
              </div>
              <Button onClick={() => viewResults(c)} variant="outline" className="w-full mt-4 gap-2" data-testid={`instr-results-${c.id}`}>
                <Eye size={16} /> Ver resultados
              </Button>
              <Link to={`/dashboard/curso-editor/${c.id}`}>
                <Button className="w-full mt-2 bg-primary text-white hover:bg-blue-600 gap-2" data-testid={`instr-edit-${c.id}`}>
                  <PencilSimple size={16} /> Editar contenido
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-2xl">
          <DialogHeader><DialogTitle className="font-display font-800">{current?.title} — Resultados</DialogTitle></DialogHeader>
          <div className="max-h-[60vh] overflow-y-auto">
            <Table>
              <TableHeader><TableRow><TableHead>Alumno</TableHead><TableHead>Avance</TableHead><TableHead>Nota</TableHead><TableHead>Estado</TableHead></TableRow></TableHeader>
              <TableBody>
                {results.length === 0 ? <TableRow><TableCell colSpan={4} className="text-center text-muted-foreground py-6">Sin alumnos aún.</TableCell></TableRow>
                  : results.map((r, i) => (
                    <TableRow key={i}>
                      <TableCell className="font-medium">{r.student}</TableCell>
                      <TableCell>{r.progress_pct}%</TableCell>
                      <TableCell>{r.grade ?? "—"}</TableCell>
                      <TableCell>{r.passed ? <Badge className="bg-primary text-white">Aprobado</Badge> : <Badge variant="outline">En curso</Badge>}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
